import { useAtom } from 'jotai'

import { globalLoadingStore } from 'src/stores/globalLoadingStore'

export const useGlobalLoadingStore = () => {
  const [globalLoadingStoreValue, setGlobalLoadingStoreValue] = useAtom(globalLoadingStore.state)

  return {
    globalLoadingStoreValue,
    setGlobalLoadingStoreValue,
  }
}
